import React from 'react';
import { useSelector } from 'react-redux';
import IncentiveTracker from '../incentives/IncentiveTracker';
import BannerMessage from '../banner/BannerMessage';
import UnsubscribeBanner from '../banner/UnsubscribeBanner';
import {
  isShippingRestrictedForParent,
  availableIncentiveProducts,
} from '../helpers/internationalRestriction';

// True when IncentiveTracker has at least one row to render. Mirrors the
// guards in IncentiveTracker so V3Layout can skip reserving 100px of top
// margin (`margin-for-incentive-tracker`) when there's no tracker.
const useIncentiveTrackerVisible = () => {
  const selectedStudent = useSelector(
    (state) => state.additionalData?.selectedStudent,
  );
  const rawIncentiveProducts = useSelector(
    (state) => state.shoot?.incentiveProducts,
  );
  const shoot = useSelector((state) => state.shoot?.shoot);
  const parent = useSelector((state) => state.parent);
  const restricted = isShippingRestrictedForParent(shoot, parent);
  const incentiveProducts = availableIncentiveProducts(
    rawIncentiveProducts,
    restricted,
  );
  return !!selectedStudent && incentiveProducts.length > 0;
};

const V3Layout = ({ children, showStudentBanner }) => {
  const loading = 'hidden';
  const trackerVisible = useIncentiveTrackerVisible();
  const containerClass = trackerVisible
    ? 'order-container margin-for-incentive-tracker'
    : 'order-container';

  return (
    <div className={containerClass}>
      <div className={loading}>
        <div className="spinner" />
      </div>
      <IncentiveTracker />
      <UnsubscribeBanner />
      <BannerMessage showStudentBanner={showStudentBanner} />
      {children}
    </div>
  );
};

export default V3Layout;
